import React from "react";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import SchedulerCalendarDaily from "../SchedulerCalendarDaily/SchedulerCalendarDaily";
import SchedulerCalendarWeekly from "../SchedulerCalendarWeekly/SchedulerCalendarWeekly";
import SchedulerTimeSlotsColumn from "../SchedulerTimeSlotsColumn/SchedulerTimeSlotsColumn";

import { calendarViews } from "../../../constants/common";

const SchedulerCalendar = (props) => {
  const { timeSlots, days, view, refresh, filters, end } = props;
  // console.log(days[0]["occurrences"])
  return (<div style={{overflowY: "scroll", maxHeight:"70vh"}}>
    <Grid item container wrap="nowrap" data-test="scheduler-calendar-component">
          <Grid item>
            <SchedulerTimeSlotsColumn
              timeSlots={timeSlots}
              occurrencesPerDay={days}
              calendarView={view}
            />
          </Grid>
          <Grid item xs>
            {view === calendarViews.daily ? (
              <SchedulerCalendarDaily
                data={days}
                timeSlots={timeSlots}
                refresh={refresh}
                showCustomTimeSlots={get(filters, ["showCustomTimeSlots"])}
              />
            ) : (
              <SchedulerCalendarWeekly
                data={days}
                timeSlots={timeSlots}
                refresh={refresh}
                showCustomTimeSlots={get(filters, ["showCustomTimeSlots"])}
                end={end}
              />
            )}
          </Grid>
        </Grid>
  </div>
    
  );
};

export default SchedulerCalendar;
